import { render, staticRenderFns } from "./HandleAssignStockSidebar.vue?vue&type=template&id=70287b8f&scoped=true&"
import script from "./HandleAssignStockSidebar.vue?vue&type=script&lang=js&"
export * from "./HandleAssignStockSidebar.vue?vue&type=script&lang=js&"
import style0 from "./HandleAssignStockSidebar.vue?vue&type=style&index=0&id=70287b8f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70287b8f",
  null
  
)

export default component.exports